import { render } from "./ShortTerm.vue?vue&type=template&id=1f6bb0c4&scoped=true"
import script from "./ShortTerm.vue?vue&type=script&lang=js"
export * from "./ShortTerm.vue?vue&type=script&lang=js"

import "./ShortTerm.vue?vue&type=style&index=0&id=1f6bb0c4&scoped=true&lang=css"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6bb0c4"]])

export default __exports__